import { FC, Fragment } from 'react';
import Tooltip from 'components/ui/Tooltip/Tooltip';
import withErrorBoundary from 'components/shared/withErrorBoundary';
import { dateFormat } from 'utils/shared/utils';

interface TicketRouteTimeProps {
  dateTime: string;
  airportDesc: string;
  airport: string;
  arrivalDaysDifference?: number;
  highlighted?: boolean;
  isShort?: boolean;
}

const TicketRouteTime: FC<TicketRouteTimeProps> = ({
  dateTime,
  airportDesc,
  airport,
  ...props
}) => {
  return (
    <div className="ticket-time">
      <div className="ticket-time-inner">
        <span className="date">{dateFormat(dateTime, 'MMM dd, yyyy')}</span>
        <span>
          <span
            dangerouslySetInnerHTML={{
              __html: dateFormat(
                dateTime,
                "'<span class=''week''>'EEE' - </span><span class=''text-bold''>'HH:mm'</span>'"
              ),
            }}
          ></span>
          {!!props.arrivalDaysDifference && (
            <span className="color-danger ml-4">+{Math.round(props.arrivalDaysDifference)}</span>
          )}
        </span>
        <span className="airport">
          {props.isShort ? (
            <Tooltip
              content={airportDesc || airport}
              children={
                <span className={'text-bold' + (props.highlighted ? ' color-danger' : '')}>
                  {airport}
                </span>
              }
            />
          ) : (
            <Fragment>
              <span className={'text-bold' + (props.highlighted ? ' color-danger' : '')}>
                {airport}
              </span>{' '}
              <span className="airport-desc">- {airportDesc}</span>
            </Fragment>
          )}
        </span>
      </div>
    </div>
  );
};

export default withErrorBoundary(TicketRouteTime, 'TicketRouteTime');
